import { ActionsObservable } from "redux-observable";
import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";

import { Effect } from "../../../../../../../../../../redux/types/effect.type";
import { isActionType } from "../../../../../../../../../../redux/action.functions";

import * as actions from "./flyer-detail-page-form-position-categories.actions";
import * as PositionCategoriesService from "../../services/flyer-detail-page-form-position-categories.service";
import { FlyerDetailPageFormPositionCategoriesActions } from "./flyer-detail-page-form-position-categories.actions";

const searchCategories: Effect = (action$: ActionsObservable<any>) =>
  action$.pipe(
    filter(isActionType(FlyerDetailPageFormPositionCategoriesActions.SearchCategory)),
    map((action) => action.payload),
    mergeMap((searchText) =>
      PositionCategoriesService.searchPositionCategories(searchText).pipe(
        map((result) => actions.searchCategorySuccess(result)),
        catchError((error) => of(actions.searchCategoryFailure(error)))
      )
    )
  );

export const FlyerDetailPageFormPositionCategoriesEffects = [searchCategories];
